import React from 'react';

const Tooltip = ({ message, buttonText, onButtonClick }) => {
    return (
        <div className="tooltip-container bg-[#212B36] rounded-lg shadow-lg px-3 py-2">
            <p className="text-white text-[0.89rem] mb-2">{message}</p>
            <button
                className=" hover:text-blue-700 text-[#85B4FF] text-sm font-medium py-1 px-2 rounded focus:outline-none"
                onClick={onButtonClick}
            >
                {buttonText}
            </button>
            <div className="tooltip-arrow"></div>
        </div>
    );
};

export default Tooltip;